// extracted by mini-css-extract-plugin
export default {"backButtonWrap":"backButtonWrap__zLbI6","backChevron":"backChevron__cjf4G","logoImg":"logoImg__d+R0N"};